/** Gift codes ignore casing and all whitespace, matching printed-card entry. */
export function normalizedGiftCode(code) {
    return code.replace(/\s+/g, "").toUpperCase();
}
